import { apiClient } from "../../../base/ApiClient";


export const getMentalCapacityAssessments = async (clientID) => {
  const res = await apiClient.get(`/assessments/consent-assessments/?client=${clientID}`);
  return res.data;
};

export const getCapacityAssessmentByReason = async (consent_reason_id) => {
  const res = await apiClient.get(`/assessments/mental-capacity/`, {
    params: { consent_reason_id },
  });
  return res.data;
};

export const createMentalCapacityAssessment = async (data) => {
  const res = await apiClient.post("/assessments/mental-capacity/", data);
  return res.data;
};

export const updateMentalCapacityAssessment = async (id, data) => {
  const res = await apiClient.put(`/assessments/mental-capacity/${id}/`, data);
  return res.data;
};

export const deleteMentalCapacityAssessment = async (id) => {
  const res = await apiClient.delete(`/assessments/mental-capacity/${id}/`);
  return res.data;
};

export const getDecisionMakers = async () => {
  const res = await apiClient.get("/assessments/decision-makers/");
  return res.data;
};

export const getDecisionMakerById = async (id) => {
  const res = await apiClient.get(`/assessments/decision-makers/${id}/`);
  return res.data;
};

export const createDecisionMaker = async (data) => {
  const res = await apiClient.post("/assessments/decision-makers/", data);
  return res.data;
};

export const updateDecisionMaker = async (id, data) => {
  const res = await apiClient.put(`/assessments/decision-makers/${id}/`, data);
  return res.data;
};

export const deleteDecisionMaker = async (id) => {
  const res = await apiClient.delete(`/assessments/decision-makers/${id}/`);
  return res.data;
};

// Consent Reasons
export const getConsentReasons = async () => {
  const res = await apiClient.get("/assessments/consent-reasons/");
  return res.data;
};

export const getConsentReasonById = async (id) => {
  const res = await apiClient.get(`/assessments/consent-reasons/${id}/`);
  return res.data;
};

export const createConsentReason = async (data) => {
  const res = await apiClient.post("/assessments/consent-reasons/", data);
  return res.data;
};

export const updateConsentReason = async (id, data) => {
  const res = await apiClient.put(`/assessments/consent-reasons/${id}/`, data);
  return res.data;
};

export const deleteConsentReason = async (id) => {
  const res = await apiClient.delete(`/assessments/consent-reasons/${id}/`);
  return res.data;
};